// @ts-expect-error not migrated TS yet

import { ACTION_MODAL_TYPES } from 'EmailComponents/utils/actions/detailActionsUtil';
import { trackFrameworkTableInteraction } from 'EmailComponents/utils/tracking';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ArchiveModal from 'email-management-lib/EmailArchiveOrDelete/components/ArchiveModal';
import DeleteModal from 'email-management-lib/EmailArchiveOrDelete/components/DeleteModal';
import useIsUngatedForNewFrameworkFolders from 'email-management-lib/refactor/components/manage/frameworkTable/hooks/useIsUngatedForNewFrameworkFolders';
import MoveToFolderMultiModal from 'email-management-lib/refactor/components/shared/MoveToFolderMultiModal';
import { View } from 'foundations-components/components/View';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { Button } from 'foundations-components/transitional/components/Button';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { HR } from 'foundations-components/transitional/components/HR';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { LockBadge } from 'foundations-components/transitional/components/LockBadge';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import ListingLibMoveAssetsModal from 'framework-listing-lib/dialog/ListingLibMoveAssetsModal';
import listingLibObserver from 'framework-listing-lib/utils/listingLibObserver';
import { List as ImmutableList } from 'immutable';
import { getInsightPolarity } from 'messaging-publishing-lib/Insights/utils';
import { useCallback, useMemo, useState } from 'react';
import { SUMMARIZE_PERFORMANCE } from '../../utils/getActions';
import { MarketingInsightsCopilotButton } from './MarketingInsightsCopilotButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function EmailGroupedActions(props) {
  const [actionName, setActionName] = useState('');
  const isUngatedForNewFrameworkFolders = useIsUngatedForNewFrameworkFolders();
  const resetActionName = useCallback(() => setActionName(''), []);
  const shouldHideViewInsightsButton = useMemo(() => {
    const {
      crmObject,
      insightContext: context
    } = props;
    const hasNoInsights = getInsightPolarity({
      crmObject,
      context
    }) === null;
    return hasNoInsights;
  }, [props]);
  const handleAction = useCallback(({
    name,
    type
  }, e) => {
    const {
      actionHandlers,
      content,
      crmObject,
      isFramework
    } = props;
    const metaCtrl = e.metaKey || e.ctrlKey;
    trackFrameworkTableInteraction({
      otherActions: `${type}-${name}`
    });
    switch (name) {
      case ACTION_MODAL_TYPES.ARCHIVE:
      case ACTION_MODAL_TYPES.CLONE:
      case ACTION_MODAL_TYPES.DELETE:
      case ACTION_MODAL_TYPES.MOVE_TO_FOLDER:
        setActionName(name);
        break;
      case ACTION_MODAL_TYPES.UNARCHIVE:
        actionHandlers[name](content, isFramework);
        if (isFramework) {
          listingLibObserver.delete(crmObject.objectId);
        }
        resetActionName();
        break;
      default:
        if (typeof actionHandlers[name] === 'function') {
          actionHandlers[name](content, isFramework, metaCtrl);
        }
    }
  }, [props, resetActionName]);
  const maybeRenderActionModal = useCallback(() => {
    const {
      crmObject,
      isFramework
    } = props;
    switch (actionName) {
      case ACTION_MODAL_TYPES.ARCHIVE:
        {
          return /*#__PURE__*/_jsx(ArchiveModal, {
            listingLibObserver: isFramework ? listingLibObserver : undefined,
            emails: [props.content],
            onClose: resetActionName
          });
        }
      case ACTION_MODAL_TYPES.DELETE:
        return /*#__PURE__*/_jsx(DeleteModal, {
          emails: [props.content],
          onClose: resetActionName,
          listingLibObserver: isFramework ? listingLibObserver : undefined
        });
      case ACTION_MODAL_TYPES.MOVE_TO_FOLDER:
        if (isUngatedForNewFrameworkFolders) {
          return /*#__PURE__*/_jsx(ListingLibMoveAssetsModal, {
            selectedObjectOrObjects: crmObject,
            onClose: resetActionName
          });
        }
        return /*#__PURE__*/_jsx(MoveToFolderMultiModal, {
          crmObject: crmObject,
          isFramework: isFramework,
          onCancel: resetActionName,
          onMoveToFolder: (e, folderId, folderName) => {
            props.actionHandlers.moveToFolder({
              selectedEmailIds: ImmutableList([props.content.id]),
              targetFolderId: folderId,
              selectedEmailNames: [props.content.name],
              targetFolderName: folderName,
              isFramework
            });
            resetActionName();
          },
          toMoveElements: [props.content]
        });
      default:
        return null;
    }
  }, [actionName, isUngatedForNewFrameworkFolders, props, resetActionName]);
  const renderActionName = useCallback(action => {
    const {
      name,
      i18n
    } = action;
    let key = `email-management.actions.names.${name}`;
    let params = {};
    if (typeof i18n !== 'undefined') {
      key = i18n.key;
      if (typeof i18n.params === 'function') {
        params = i18n.params();
      }
    }
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: key,
      options: params
    });
  }, []);
  const renderPrimaryAction = useCallback(action => {
    const {
      onUpdateIsPrimaryActionTooltipOpen,
      content
    } = props;
    const actionButton = /*#__PURE__*/_jsxs(Button, {
      "data-test-id": `primary-content-action-${action.name}`,
      disabled: action.disabled,
      onClick: e => handleAction({
        name: action.name,
        type: 'primary'
      }, e),
      size: "extra-small",
      use: "tertiary-light",
      children: [renderActionName(action), action.icon && /*#__PURE__*/_jsx(IconHolder, {
        icon: action.icon,
        padding: "0"
      })]
    }, action.name);
    if (action.tooltip) {
      return /*#__PURE__*/_jsx(Tooltip, {
        onOpenChange: ({
          target: {
            value
          }
        }) => onUpdateIsPrimaryActionTooltipOpen({
          open: value,
          emailId: content.id
        }),
        placement: "top",
        title: action.tooltip,
        children: actionButton
      }, action.name);
    }
    return actionButton;
  }, [handleAction, props, renderActionName]);
  const renderMenuActions = useCallback((secondaryActions = [], primaryActions = []) => {
    const actions = [...primaryActions, ...secondaryActions];
    return /*#__PURE__*/_jsx(List, {
      "data-test-id": "menu-actions-list",
      children: actions.map(action => {
        if (action.name === SUMMARIZE_PERFORMANCE && props.content) {
          return [action.divider && /*#__PURE__*/_jsx(HR, {
            distance: "xs"
          }), /*#__PURE__*/_jsx(ListItem, {
            children: /*#__PURE__*/_jsx(MarketingInsightsCopilotButton, {
              "data-test-id": `primary-content-action-${action.name}`,
              emailId: props.content.crmObjectId,
              objectName: props.content.name
            })
          }, action.name)];
        }
        let button = /*#__PURE__*/_jsxs(Button, {
          "data-test-id": `menu-content-action-${action.name}`,
          disabled: action.disabled,
          onClick: e => handleAction({
            name: action.name,
            type: 'menu'
          }, e),
          children: [renderActionName(action), action.icon && /*#__PURE__*/_jsx(IconHolder, {
            marginInlineStart: "300",
            padding: "0",
            icon: action.icon
          }), action.isLocked && /*#__PURE__*/_jsx(LockBadge, {}), action.isNew && /*#__PURE__*/_jsx(Badge, {
            use: "new",
            marginInlineStart: "200",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "email-management.details.header.actions.new"
            })
          }), action.isBeta && /*#__PURE__*/_jsx(Badge, {
            use: "beta",
            marginInlineStart: "200",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "email-management.header.beta"
            })
          })]
        }, action.name);
        if (action.tooltip) {
          button = /*#__PURE__*/_jsx(Tooltip, {
            placement: "left",
            title: action.tooltip,
            children: button
          }, action.name);
        }
        return [action.divider && /*#__PURE__*/_jsx(HR, {
          distance: "xs"
        }), /*#__PURE__*/_jsx(ListItem, {
          children: button
        }, action.name)];
      })
    });
  }, [handleAction, props.content, renderActionName]);
  const renderMoreMenuButton = useCallback(() => {
    const {
      availableActions,
      isPreviewFooter
    } = props;
    const {
      secondary
    } = availableActions;
    if (!secondary || secondary.length === 0) {
      return null;
    }
    return /*#__PURE__*/_jsx(Dropdown, {
      animateOnToggle: isPreviewFooter,
      buttonSize: "extra-small",
      buttonText: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "email-management.actions.button.text"
      }),
      buttonUse: "tertiary-light",
      closeOnOutsideClick: true,
      "data-test-id": "actions-button",
      placement: "bottom",
      children: renderMenuActions(secondary)
    });
  }, [props, renderMenuActions]);
  const {
    availableActions,
    selectedEmailCount,
    isPreviewFooter
  } = props;
  return /*#__PURE__*/_jsxs(View, {
    children: [(selectedEmailCount === 0 || isPreviewFooter) && /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsxs(ButtonWrapper, {
        horizontalGap: 6,
        marginBlock: "100",
        children: [availableActions.primary.map(action => {
          if (action.name === 'viewInsights' && shouldHideViewInsightsButton) return null;
          return renderPrimaryAction(action);
        }), renderMoreMenuButton()]
      })
    }), maybeRenderActionModal()]
  });
}